var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.57692 7.704C10.2099 6.568 10.5269 6 10.9999 6C11.4729 6 11.7899 6.568 12.4229 7.704L12.5869 7.998C12.7669 8.321 12.8569 8.482 12.9969 8.588C13.1369 8.695 13.3129 8.735 13.6619 8.814L13.9799 8.886C15.2099 9.164 15.8249 9.303 15.9709 9.774C16.1179 10.244 15.6979 10.734 14.8599 11.715L14.6429 11.969C14.4049 12.247 14.2859 12.387 14.2329 12.559C14.1779 12.731 14.1959 12.917 14.2329 13.289L14.2649 13.627C14.3919 14.935 14.4549 15.589 14.0719 15.88C13.6889 16.17 13.1139 15.906 11.9619 15.376L11.6639 15.238C11.3369 15.088 11.1739 15.012 10.9999 15.012C10.8269 15.012 10.6629 15.088 10.3359 15.238L10.0379 15.376C8.88592 15.906 8.31092 16.171 7.92792 15.88C7.54492 15.59 7.60792 14.935 7.73492 13.627L7.76692 13.289C7.80392 12.917 7.82192 12.731 7.76692 12.559C7.71392 12.387 7.59492 12.247 7.35692 11.969L7.13992 11.715C6.30192 10.735 5.88192 10.245 6.02892 9.774C6.17492 9.304 6.78892 9.164 8.01892 8.886L8.33792 8.814C8.68792 8.734 8.86192 8.695 9.00292 8.589C9.14292 8.482 9.23292 8.321 9.41292 7.999L9.57692 7.704Z",
    stroke: "#FF3093",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 1V3M11 19V21M1 11H3M19 11H21M5 17L5.343 16.657M16.657 5.343L17 5M17 17L16.657 16.657M5.343 5.343L5 5",
    stroke: "#FF3093",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlight);
export default __webpack_public_path__ + "static/media/highlight.d38cb23664fb1e2f0270361ba64fe843.svg";
export { ForwardRef as ReactComponent };